import React from 'react';
import { Building2, Check, CheckCircle, Globe, MapPin, Plus, Save, Send, Trash2, UserPlus, Users, XCircle } from 'lucide-react';

const LocationsTab = ({ ctx }) => {
  const {  members, analytics, locationsData, subAdmins, API_URL, getToken, showAddLocation, locationForm, subAdminForm, setShowAddLocation, setLocationForm, setSubAdminForm , setShowInviteSubAdmin, showInviteSubAdmin, setLocationsData, setSubAdmins } = ctx;

  return (
<div data-testid="locations-tab">
  <div className="flex items-center justify-between mb-1">
    <h1 className="text-xl font-bold" style={{ color: '#1A1209' }}>Locations & Sub-Admins</h1>
    <button onClick={() => setShowAddLocation(!showAddLocation)}
      className="px-4 py-2 rounded-lg text-xs font-semibold text-white flex items-center gap-1.5"
      style={{ backgroundColor: '#F5831F' }} data-testid="add-location-btn">
      <Plus size={13} /> Add Location
    </button>
  </div>
  <p className="text-xs mb-5" style={{ color: '#999' }}>
    Manage branch offices and invite sub-admins to oversee specific locations. Sub-admins see only their location&apos;s data.
  </p>

  {/* Add location form */}
  {showAddLocation && (
    <div className="bg-white rounded-xl p-5 mb-5" style={{ border: '2px solid #F5831F33' }} data-testid="location-form">
      <h3 className="text-sm font-bold mb-3" style={{ color: '#1A1209' }}>New Location</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        <input value={locationForm.name} onChange={e => setLocationForm(p => ({ ...p, name: e.target.value }))}
          placeholder="Location name *" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="location-name" />
        <input value={locationForm.city} onChange={e => setLocationForm(p => ({ ...p, city: e.target.value }))}
          placeholder="City" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="location-city" />
        <select value={locationForm.state} onChange={e => setLocationForm(p => ({ ...p, state: e.target.value }))}
          className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="location-state">
          <option value="">Select State</option>
          {['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'].map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div className="flex gap-2">
        <button onClick={async () => {
          if (!locationForm.name.trim()) return;
          try {
            const res = await fetch(`${API_URL}/api/corporate/locations`, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
              body: JSON.stringify(locationForm),
            });
            if (res.ok) {
              setLocationForm({ name: '', city: '', state: '', country: 'United States', timezone_str: 'America/New_York' });
              setShowAddLocation(false);
              const r2 = await fetch(`${API_URL}/api/corporate/locations`, { headers: { Authorization: `Bearer ${getToken()}` } });
              if (r2.ok) { const d = await r2.json(); setLocationsData(d.locations || []); }
            }
          } catch {}
        }} disabled={!locationForm.name.trim()}
          className="px-4 py-2 rounded-lg text-sm font-medium text-white disabled:opacity-50 flex items-center gap-1.5"
          style={{ backgroundColor: '#2EAA5C' }} data-testid="save-location-btn">
          <Check size={14} /> Save Location
        </button>
        <button onClick={() => setShowAddLocation(false)} className="px-4 py-2 rounded-lg text-sm" style={{ backgroundColor: '#F0F0F0', color: '#666' }}>Cancel</button>
      </div>
    </div>
  )}

  {/* Locations list */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
    {locationsData.map(loc => (
      <div key={loc.location_id} className="bg-white rounded-xl p-5" style={{ border: loc.is_hq ? '2px solid #F5831F33' : '1px solid #E8E8E8' }} data-testid={`location-${loc.location_id}`}>
        <div className="flex items-center gap-2 mb-2">
          <MapPin size={16} style={{ color: loc.is_hq ? '#F5831F' : '#6B7280' }} />
          <h4 className="text-sm font-bold" style={{ color: '#1A1209' }}>{loc.name}</h4>
          {loc.is_hq && <span className="px-2 py-0.5 rounded-full text-[9px] font-bold" style={{ backgroundColor: '#F5831F15', color: '#F5831F' }}>HQ</span>}
        </div>
        <div className="space-y-1">
          {loc.city && <p className="text-xs flex items-center gap-1.5" style={{ color: '#666' }}><Globe size={10} /> {loc.city}{loc.state ? `, ${loc.state}` : ''}</p>}
          <p className="text-xs" style={{ color: '#999' }}>{loc.country || 'United States'}</p>
          {loc.member_count !== undefined && (
            <p className="text-xs font-semibold flex items-center gap-1.5" style={{ color: '#1A1209' }}>
              <Users size={10} style={{ color: '#2563EB' }} /> {loc.member_count} members
            </p>
          )}
        </div>
      </div>
    ))}
  </div>

  {/* Sub-Admins Section */}
  <div className="mb-1">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-bold" style={{ color: '#1A1209' }}>Sub-Admins</h2>
      <button onClick={() => setShowInviteSubAdmin(!showInviteSubAdmin)}
        className="px-3 py-2 rounded-lg text-xs font-medium text-white flex items-center gap-1.5"
        style={{ backgroundColor: '#8B5CF6' }} data-testid="invite-sub-admin-btn">
        <UserPlus size={13} /> Invite Sub-Admin
      </button>
    </div>
    <p className="text-xs mb-4" style={{ color: '#999' }}>
      Sub-admins manage specific locations. They can view analytics and manage members for their assigned branch only.
    </p>
  </div>

  {/* Invite sub-admin form */}
  {showInviteSubAdmin && (
    <div className="bg-white rounded-xl p-5 mb-5" style={{ border: '2px solid #8B5CF622' }} data-testid="sub-admin-form">
      <h3 className="text-sm font-bold mb-3" style={{ color: '#1A1209' }}>Invite New Sub-Admin</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        <input value={subAdminForm.name} onChange={e => setSubAdminForm(p => ({ ...p, name: e.target.value }))}
          placeholder="Full name *" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="sub-admin-name" />
        <input value={subAdminForm.email} onChange={e => setSubAdminForm(p => ({ ...p, email: e.target.value }))}
          placeholder="Email *" type="email" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="sub-admin-email" />
        <select value={subAdminForm.location_id} onChange={e => setSubAdminForm(p => ({ ...p, location_id: e.target.value }))}
          className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="sub-admin-location">
          <option value="">All Locations</option>
          {locationsData.map(l => <option key={l.location_id} value={l.location_id}>{l.name}</option>)}
        </select>
      </div>
      <div className="mb-3">
        <p className="text-[10px] font-semibold uppercase tracking-wider mb-2" style={{ color: '#999' }}>Permissions</p>
        <div className="flex flex-wrap gap-2">
          {['view_analytics', 'manage_members', 'manage_scenarios', 'send_nudges', 'view_reports'].map(perm => (
            <label key={perm} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg cursor-pointer text-xs" style={{
              backgroundColor: subAdminForm.permissions.includes(perm) ? '#8B5CF615' : '#F8F7F4',
              color: subAdminForm.permissions.includes(perm) ? '#8B5CF6' : '#999',
              border: `1px solid ${subAdminForm.permissions.includes(perm) ? '#8B5CF633' : '#E8E8E8'}`,
            }}>
              <input type="checkbox" checked={subAdminForm.permissions.includes(perm)} onChange={e => {
                setSubAdminForm(p => ({
                  ...p,
                  permissions: e.target.checked ? [...p.permissions, perm] : p.permissions.filter(pp => pp !== perm),
                }));
              }} className="hidden" />
              {subAdminForm.permissions.includes(perm) ? <CheckCircle size={12} /> : <XCircle size={12} />}
              {perm.replace(/_/g, ' ')}
            </label>
          ))}
        </div>
      </div>
      <div className="flex gap-2">
        <button onClick={async () => {
          if (!subAdminForm.name.trim() || !subAdminForm.email.trim()) return;
          try {
            const res = await fetch(`${API_URL}/api/corporate/sub-admins/invite`, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
              body: JSON.stringify(subAdminForm),
            });
            if (res.ok) {
              setSubAdminForm({ email: '', name: '', location_id: '', permissions: ['view_analytics', 'manage_members'] });
              setShowInviteSubAdmin(false);
              const r2 = await fetch(`${API_URL}/api/corporate/sub-admins`, { headers: { Authorization: `Bearer ${getToken()}` } });
              if (r2.ok) { const d = await r2.json(); setSubAdmins(d.sub_admins || []); }
            }
          } catch {}
        }} disabled={!subAdminForm.name.trim() || !subAdminForm.email.trim()}
          className="px-4 py-2 rounded-lg text-sm font-medium text-white disabled:opacity-50 flex items-center gap-1.5"
          style={{ backgroundColor: '#2EAA5C' }} data-testid="save-sub-admin-btn">
          <Check size={14} /> Send Invite
        </button>
        <button onClick={() => setShowInviteSubAdmin(false)} className="px-4 py-2 rounded-lg text-sm" style={{ backgroundColor: '#F0F0F0', color: '#666' }}>Cancel</button>
      </div>
    </div>
  )}

  {/* Sub-admins list */}
  {subAdmins.length > 0 ? (
    <div className="bg-white rounded-xl overflow-hidden" style={{ border: '1px solid #E8E8E8' }}>
      <table className="w-full">
        <thead>
          <tr style={{ backgroundColor: '#F8F7F4', borderBottom: '1px solid #E8E8E8' }}>
            {['Name', 'Email', 'Location', 'Permissions', 'Status', ''].map(h => (
              <th key={h} className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {subAdmins.map(sa => (
            <tr key={sa.sub_admin_id} className="hover:bg-gray-50" style={{ borderBottom: '1px solid #F0F0F0' }} data-testid={`sub-admin-${sa.sub_admin_id}`}>
              <td className="px-4 py-3 text-sm font-medium" style={{ color: '#1A1209' }}>{sa.name}</td>
              <td className="px-4 py-3 text-xs" style={{ color: '#666' }}>{sa.email}</td>
              <td className="px-4 py-3 text-xs" style={{ color: '#666' }}>
                {locationsData.find(l => l.location_id === sa.location_id)?.name || 'All Locations'}
              </td>
              <td className="px-4 py-3">
                <div className="flex flex-wrap gap-1">
                  {sa.permissions?.map(p => (
                    <span key={p} className="px-1.5 py-0.5 rounded text-[8px] font-medium" style={{ backgroundColor: '#8B5CF615', color: '#8B5CF6' }}>
                      {p.replace(/_/g, ' ')}
                    </span>
                  ))}
                </div>
              </td>
              <td className="px-4 py-3">
                <span className="px-2 py-0.5 rounded-full text-[10px] font-bold" style={{ backgroundColor: '#ECFDF5', color: '#059669' }}>Active</span>
              </td>
              <td className="px-4 py-3 text-right">
                <button onClick={async () => {
                  if (!window.confirm(`Remove ${sa.name} as sub-admin?`)) return;
                  await fetch(`${API_URL}/api/corporate/sub-admins/${sa.sub_admin_id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${getToken()}` } });
                  const r2 = await fetch(`${API_URL}/api/corporate/sub-admins`, { headers: { Authorization: `Bearer ${getToken()}` } });
                  if (r2.ok) { const d = await r2.json(); setSubAdmins(d.sub_admins || []); }
                }} className="p-1.5 rounded hover:bg-gray-100" data-testid={`remove-sub-admin-${sa.sub_admin_id}`}>
                  <Trash2 size={13} style={{ color: '#DC2626' }} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="bg-white rounded-xl p-8 text-center" style={{ border: '1px solid #E8E8E8' }}>
      <Building2 size={32} style={{ color: '#DDD' }} className="mx-auto mb-3" />
      <p className="text-sm" style={{ color: '#999' }}>No sub-admins yet. Invite branch managers to give them scoped access to their location&apos;s data.</p>
    </div>
  )}
</div>
  );
};

export default LocationsTab;
